export default __webpack_public_path__ + "static/media/project_3.11c1be8d.jpg";